import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useMemo, useState } from "react";
import { Box, Stack, Tab, Tabs } from "@mui/material";
import useTabHash from "./useTabHash";
function resolveThemeOverride(slot, theme, ownerState) {
    if (!slot) {
        return {};
    }
    return typeof slot === "function" ? slot({ theme, ownerState }) : slot;
}
function a11yProps(id) {
    return {
        id,
        "aria-controls": `${id}-panel`,
    };
}
function CustomTabPanel(props) {
    const { children, value, index, dir, tabId, ...other } = props;
    return (_jsx(Box, { role: "tabpanel", hidden: value !== index, id: `${tabId}-panel`, "aria-labelledby": tabId, dir: dir, ...other, sx: { width: "100%" }, children: value === index && (_jsx(Box, { sx: {
                pl: { xs: 0, md: dir === "vertical" ? 5 : 0 },
                "& > .MuiBox-root:first-child": {
                    pt: { xs: undefined, md: dir === "vertical" ? 0 : undefined },
                },
            }, children: children })) }));
}
const TabsComponent = (props) => {
    const { direction = "horizontal", style = "text", color = "primary", tabs, } = props;
    const [value, setValue] = useState(0);
    const tabsArray = useMemo(() => {
        if (tabs?.tabs && !Array.isArray(tabs?.tabs)) {
            return [tabs?.tabs];
        }
        return tabs?.tabs || [];
    }, [tabs]);
    useTabHash(tabsArray, setValue);
    const handleChange = (_event, newValue) => {
        setValue(newValue);
    };
    const baseTabSx = useMemo(() => {
        if (direction === "vertical") {
            return {
                opacity: 1,
                alignItems: "flex-start",
                flexShrink: 0,
                minWidth: "max-content",
                textAlign: "left",
                whiteSpace: "nowrap",
            };
        }
        return {
            opacity: 1,
            flexShrink: 0,
            minWidth: "max-content",
            whiteSpace: "nowrap",
        };
    }, [direction]);
    return (_jsxs(Stack, { direction: {
            xs: "column",
            md: direction === "vertical" ? "row" : "column",
        }, children: [_jsx(Tabs, { value: value, onChange: handleChange, variant: "standard", orientation: direction, textColor: style === "text" ? color : "inherit", indicatorColor: color, sx: {
                    minWidth: "max-content",
                    "& .MuiTabs-list": {
                        gap: "16px",
                    },
                    ...(style === "contained"
                        ? {
                            "& .MuiTabs-indicator": {
                                display: "none",
                            },
                        }
                        : {}),
                }, children: tabsArray?.map((tab) => (_jsx(Tab, { label: tab.title, ...a11yProps(tab.id), sx: style === "contained"
                        ? (theme) => ({
                            ...baseTabSx,
                            ...resolveThemeOverride(theme.components?.MuiButton?.styleOverrides?.root, theme, {
                                variant: "contained",
                                color,
                            }),
                            // Désactive l'animation d'underline au hover héritée du MuiButton
                            "&::after": { display: "none" },
                            "&:not(.Mui-disabled):hover::after": {
                                transform: "none",
                            },
                            "&.Mui-selected": {
                                ...resolveThemeOverride(theme.components?.MuiButton?.styleOverrides?.contained, theme, {
                                    variant: "contained",
                                    color,
                                }),
                                ...resolveThemeOverride(color === "primary"
                                    ? theme.components?.MuiButton?.styleOverrides
                                        ?.containedPrimary
                                    : theme.components?.MuiButton?.styleOverrides
                                        ?.containedSecondary, theme, {
                                    variant: "contained",
                                    color,
                                }),
                            },
                        })
                        : baseTabSx }, tab.id))) }), tabsArray?.map((tab, index) => (_jsx(CustomTabPanel, { value: value, index: index, tabId: tab.id, dir: direction, children: tab.children }, `${tab.title}-${index}`)))] }));
};
export default TabsComponent;
